import * as React from "react"
import {IconSeeker} from "@ui-seeker/core";
import {Typography} from "@mui/material";


export default function RepricingCrudFormTitleRow({ icon, title, subtitle }) {
	return <Typography variant="h6">
		<IconSeeker icon={icon} sx={{ mr: 1 }} />
		{title}
		<Typography variant="caption" sx={{ ml: 1, fontStyle: 'italic' }}>
			{subtitle}
		</Typography>
	</Typography>
}